import { AutogenLayoutMobileCommSendLoadHistoryList } from "./autogen/AutogenLayoutMobileCommSendLoadHistoryList";
import { LookupModelSearchEvent, TableRowDisplayEvent, Textbox } from "@mcleod/components";

export class MobileCommSendLoadHistoryList extends AutogenLayoutMobileCommSendLoadHistoryList {
    private readonly RECORD_TYPE_ROUTE = 'R';
    private readonly RECORD_TYPE_STOP = 'S';
    private readonly RECORD_TYPE_LOCATION = 'L';

    /** This is an event handler for the beforeLookupModelSearch event of textboxMcControlIdSearch. */
    textboxMcControlIdSearchBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = 'Y';
    }

    /** This is an event handler for the onRowDisplay event of tableSendLoadHistory. */
    tableSendLoadHistoryOnRowDisplay(event: TableRowDisplayEvent) {
        this.defineLocalTooltip(event.target.findComponentById("textboxLocalId") as Textbox, event.getTableRow().data.data.record_type, event.getTableRow().data.data.local_id);
    }

    private defineLocalTooltip(local_id_textbox: Textbox, record_type: string, local_id: string): void {
        if (record_type === this.RECORD_TYPE_ROUTE) {
            local_id_textbox.quickInfoLayout = 'lme/powerbroker/MovementQuickInfo';
            local_id_textbox.quickInfoOverrideKeyValue = local_id.split('-')[0];
        } else if (record_type === this.RECORD_TYPE_STOP) {
            local_id_textbox.quickInfoLayout = 'lme/dispatch/StopQuickInfo';
            local_id_textbox.quickInfoOverrideKeyValue = local_id;
        } else if (record_type === this.RECORD_TYPE_LOCATION) {
            local_id_textbox.quickInfoLayout = 'lme/dispatch/LocationQuickInfo';
            local_id_textbox.quickInfoOverrideKeyValue = local_id;
        }
    }
}
